import React from "react";
import Chart from "react-apexcharts";

const RadialSoilScoreChart = ({ value = 0, label = "Soil Score" }) => {
  // Dynamic color based on value
  const getColor = (val) => {
    if (val >= 70) return "#28a745"; // Green
    if (val >= 40) return "#28a745"; // Yellow
    return "#28a745"; // Red
  };

  const options = {
    chart: {
      type: "radialBar",
      sparkline: {
        enabled: true,
      },
      animations: {
        enabled: true,
        speed: 1000,
        animateGradually: { enabled: true, delay: 200 },
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "65%",
          background: "#f9f9f9",
        },
        track: {
          background: "#e6e6e6",
          strokeWidth: "100%",
        },
        dataLabels: {
          name: {
            fontSize: "16px",
            fontWeight: 700,
            color: "rgba(95, 94, 94, 0.92941176",
            offsetY: 35,
            
          },
          value: {
            fontSize: "28px",
            fontWeight: "bold",
            formatter: (val) => `${val}`, // Add % if needed
            color: "#111",
            offsetY: -10,
          },
        },
      },
    },
    labels: [label],
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: [getColor(value)],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    colors: [getColor(value)],
    stroke: {
      lineCap: "round",
    },
  };

  const series = [value];

  return <Chart options={options} series={series} type="radialBar" height={220} />;
};

export default RadialSoilScoreChart;
